import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';
import { Button, type ButtonProps } from './button.js';
import { Tooltip } from './menu.js';

export type IconButtonProps = Omit<ButtonProps, 'size' | 'children' | 'icon'> & {
  /** Accessible name; also shown as a tooltip. Required: an icon alone is not a label. */
  label: string;
  icon: ReactNode;
  /** Hide the tooltip (the label is still announced). */
  noTooltip?: boolean;
};

export function IconButton({
  label,
  icon,
  noTooltip,
  variant = 'ghost',
  className,
  ...props
}: IconButtonProps) {
  const button = (
    <Button
      variant={variant}
      size="icon"
      aria-label={label}
      className={cn('[&_svg]:size-[1.25em]', className)}
      {...props}
    >
      {icon}
    </Button>
  );
  return noTooltip ? button : <Tooltip content={label}>{button}</Tooltip>;
}
